export default "__VITE_ASSET__C71cIMmo__"